export function uniAddClass(element, value, prefix = '', suffix = '') {
  if (value && value !== '') {
    element.classList.add(`${prefix}${value}${suffix}`);
  }
}
